/**
 * Canonical map of top-level RBAC tab codes to their routes, in nav priority order.
 *
 * Single source of truth for deciding a user's landing page: their home is the first
 * tab (in this order) they're permitted to see. Keep this aligned with the tab order
 * in SubNav and the routes declared in App.tsx.
 */
export const TAB_ROUTES: ReadonlyArray<{ code: string; route: string }> = [
  { code: "ALERTS", route: "/" },
  { code: "SECURITY_ALERTS", route: "/securityAlerts" },
  { code: "DEPLOYMENT", route: "/deployments" },
  { code: "SERVICE_HEALTH", route: "/serviceHealth" },
  { code: "SERVICEHEALTH", route: "/serviceHealth" },
  { code: "ALERTS_TREND", route: "/alertsTrend" },
  { code: "COST", route: "/costManagement/dashboard" },
  { code: "ALERTS_SUPPRESSION", route: "/suppression" },
  { code: "ADMIN", route: "/admin" },
];

/**
 * Returns the route of the first tab the user is permitted to see (their home page),
 * or null when their permission set grants no known tab.
 */
export function getFirstAllowedRoute(
  tabPermissions: Record<string, boolean>,
): string | null {
  const match = TAB_ROUTES.find((t) => t.code in tabPermissions);
  return match ? match.route : null;
}
